function openModal(modalId) {
    try {
        const modal = document.getElementById(modalId);
        if (!modal) {
            console.error(`Modal con id ${modalId} no encontrado`);
            return;
        }
        
        modal.style.display = "flex";
        document.body.classList.add("lpb-modal-open");
        
        // Disparar evento personalizado
        document.dispatchEvent(new CustomEvent('modalOpened', { 
            detail: { modalId } 
        }));
    } catch (error) {
        console.error('Error al abrir el modal:', error);
    }
}

function pauseEkooMediaInRoot(root) {
    root.querySelectorAll("[data-ekoo]").forEach((ekooElement) => {
        pauseEkooMedia(ekooElement);
    });
}

function pauseEkooMedia(root) {
    root.querySelectorAll("audio, video").forEach((media) => {
        if (typeof media.pause === "function") media.pause();
    });

    root.querySelectorAll("iframe").forEach((iframe) => {
        if (iframe.contentWindow) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
        }

        const src = iframe.getAttribute("src");
        if (src) {
            iframe.setAttribute("src", src);
        }
    });

    root.querySelectorAll("*").forEach((element) => {
        if (element.shadowRoot) pauseEkooMedia(element.shadowRoot);
    });
}

function closeModal(event, modalId) {
    try {
        const { target } = event;
        const isModalCloseElement =
            target.classList.contains("modal") ||
            target.classList.contains("lpb-modal-close-area") ||
            target.classList.contains("lpb-modal-close") ||
            target.classList.contains("lpb-modal-close-retour") ||
            target.classList.contains("button--annule") ||
            target.classList.contains("fa-xmark");

        if (isModalCloseElement) {
            const modal = document.getElementById(modalId);
            if (!modal) {
                console.error(`Modal con id ${modalId} no encontrado`);
                return;
            }

            pauseEkooMediaInRoot(modal);
            modal.style.display = "none";
            document.body.classList.remove("lpb-modal-open");

            // Disparar evento personalizado
            document.dispatchEvent(new CustomEvent('modalClosed', { 
                detail: { modalId } 
            }));
        }
    } catch (error) {
        console.error('Error al cerrar el modal:', error);
    }
}

function initializeSlider(sliderId) {
    const slider = document.getElementById(sliderId);
    const slides = slider.querySelectorAll(".lpb-slider__slide");
    const indicatorsContainer = document.querySelector(
        `.lpb-slider__indicators[data-slider=${sliderId}]`
    );
    const prevButton = document.querySelector(
        `.lpb-slider-button.prev[data-slider=${sliderId}]`
    );
    const nextButton = document.querySelector(
        `.lpb-slider-button.next[data-slider=${sliderId}]`
    );
    let currentIndex = 0;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    slides.forEach((_, index) => {
        const indicator = document.createElement("div");
        indicator.classList.add("lpb-slider__indicator");
        if (index === 0) {
            indicator.classList.add("active");
        }
        indicator.addEventListener("click", () => {
            goToSlide(index);
        });
        const icon = document.createElement("i");
        icon.classList.add("fa-regular", "fa-circle");
        indicator.appendChild(icon);
        indicatorsContainer.appendChild(indicator);
    });

    function goToSlide(index) {
        slider.style.transform = `translateX(-${index * 100}%)`;
        currentIndex = index;
        updateIndicators();
        updateNavButtons();
    }

    function updateIndicators() {
        const indicators = indicatorsContainer.querySelectorAll(".lpb-slider__indicator");
        indicators.forEach((indicator, index) => {
            indicator.classList.toggle("active", index === currentIndex);
        });
    }

    function updateNavButtons() {
        prevButton.classList.toggle("hidden", currentIndex === 0);
        nextButton.classList.toggle(
            "hidden",
            currentIndex === slides.length - 1
        );
    }

    prevButton.addEventListener("click", () => {
        if (currentIndex > 0) {
            goToSlide(currentIndex - 1);
        }
    });

    nextButton.addEventListener("click", () => {
        if (currentIndex < slides.length - 1) {
            goToSlide(currentIndex + 1);
        }
    });

    slider.addEventListener("touchstart", handleTouchStart);
    slider.addEventListener("touchmove", handleTouchMove);
    slider.addEventListener("touchend", handleTouchEnd);

    function handleTouchStart(event) {
        startX = event.touches[0].clientX;
        isDragging = true;
    }

    function handleTouchMove(event) {
        if (!isDragging) return;
        currentX = event.touches[0].clientX;
        const diffX = startX - currentX;
        if (Math.abs(diffX) > 50) {
            if (diffX > 0 && currentIndex < slides.length - 1) {
                goToSlide(currentIndex + 1);
            } else if (diffX < 0 && currentIndex > 0) {
                goToSlide(currentIndex - 1);
            }
            isDragging = false;
        }
    }

    function handleTouchEnd() {
        isDragging = false;
    }

    updateNavButtons();
}

function initLpbSnapSliders(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const sliders = [];

    if (scope instanceof Element && scope.matches("[data-lpb-snap-slider]")) {
        sliders.push(scope);
    }

    sliders.push(...scope.querySelectorAll("[data-lpb-snap-slider]"));

    sliders.forEach((slider) => {
        const mobileMax = Number(slider.dataset.sliderMobileMax || "749");
        if (window.innerWidth > mobileMax || slider.dataset.sliderReady === "true") return;

        const track = slider.querySelector("[data-lpb-snap-track]");
        const dotsContainer = slider.querySelector("[data-lpb-snap-dots]");

        if (!track || !dotsContainer) return;

        const slides = Array.from(track.querySelectorAll("[data-lpb-snap-slide]"));
        const dots = Array.from(dotsContainer.querySelectorAll("[data-lpb-snap-dot]"));

        if (!slides.length || slides.length !== dots.length) return;

        slider.dataset.sliderReady = "true";

        const setActiveDot = (index) => {
            dots.forEach((dot, dotIndex) => {
                const isActive = dotIndex === index;
                dot.classList.toggle("is-active", isActive);
                dot.setAttribute("aria-pressed", isActive ? "true" : "false");
            });
        };

        const syncActiveDot = () => {
            const trackCenter = track.scrollLeft + track.clientWidth / 2;
            let closestIndex = 0;
            let closestDistance = Number.POSITIVE_INFINITY;

            slides.forEach((slide, index) => {
                const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
                const distance = Math.abs(slideCenter - trackCenter);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = index;
                }
            });

            setActiveDot(closestIndex);
        };

        dots.forEach((dot, index) => {
            dot.addEventListener("click", () => {
                slides[index].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start",
                });
                setActiveDot(index);
            });
        });

        let scrollTimeout;
        track.addEventListener(
            "scroll",
            () => {
                window.clearTimeout(scrollTimeout);
                scrollTimeout = window.setTimeout(syncActiveDot, 80);
            },
            { passive: true }
        );

        syncActiveDot();
    });
}

      document.addEventListener("click", function (event) {
        const toggle = event.target.closest(".show-hide-pass");
        if (!toggle) return;

        const container = toggle.parentElement;
        const passwordInput = container
          ? container.querySelector("input[type='password'], input[type='text']")
          : null;
        const icon = toggle.querySelector("i");

        if (!passwordInput) return;

        if (passwordInput.getAttribute("type") === "password") {
          passwordInput.setAttribute("type", "text");
          if (icon) icon.className = "fa-solid fa-eye-slash";
        } else {
          passwordInput.setAttribute("type", "password");
          if (icon) icon.className = "fa-regular fa-eye";
        }
      });

      document.addEventListener("DOMContentLoaded", function () {
        const links = document.querySelectorAll("[data-href]");

        links.forEach(link => {
          const hrefValue = link.getAttribute("data-href");
          if (hrefValue) {
            link.setAttribute("href", hrefValue);
          }
        });

        initLpbSnapSliders(document);
      });

      document.addEventListener("shopify:section:load", function (event) {
        initLpbSnapSliders(event.target);
      });
